export const faqItems = [
  {
    q: 'Do you ship internationally?',
    a: 'We are preparing shipping options for painted physical pieces. Check back soon for updates.',
  },
  {
    q: 'Can I request a specific size or color not listed for a product?',
    a: 'Yes. Visit our Custom Orders page to describe your exact requirements. A custom order may come at a premium price, and an extended lead time.',
  },
  {
    q: 'Can I request a custom fairy door or creature?',
    a: 'Yes. Visit our Custom Orders page to describe your idea, preferred size, finish, and timeline. We will reply within 24–48 hours.',
  },
  {
    q: 'What else can you make, that isnt fairy garden products?',
    a: 'We are happy to discuss any custom order to meet your needs. There are some examples of interesting projects on the Custom Orders page.',
  },
  {
    q: 'How should I care for painted outdoor pieces?',
    a: 'See our Care & Painting Guide for cleaning, touch-ups, and seasonal storage tips to keep your fairy garden looking magical year-round.',
  },
  {
    q: 'Do you use AI to design your models?',
    a: 'No. Every Fae Forest design is created by hand, from first sketch through digital modelling, testing, and finishing.',
  },
  {
    q: 'Can I print these designs at home if I have a 3D printer?',
    a: 'Many of our pieces are available as STL files on MyMiniFactory and Cults3D. Check each product page for marketplace links. Personal use is permitted; commercial redistribution of STL files is not.',
  },
  {
    q: 'What is the difference between printed and painted pieces?',
    a: 'Printed pieces are raw 3D prints ready for you to finish with your own creative flourish. Painted pieces are hand-finished by us with priming, detailed painting, and sealing for outdoor display.',
  },
  {
    q: 'What material do you recommend for home 3D printing?',
    a: 'PLA works well for display pieces. For outdoor use, consider PETG or ASA and apply a UV-resistant clear coat after painting. Highest detail prints require a resin 3D printer for best results.',
  },
];
